// FieldTitle Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class FieldTitle extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      title: ''
    }
  }

  render () {
    const { title } = this.props

    return (
      <div className='field-title'>
        <IntlMessage ident={title} />
      </div>
    )
  }
}

export default FieldTitle
